import { render } from "./risklabelTable.vue?vue&type=template&id=203e01cb"
import script from "./risklabelTable.vue?vue&type=script&lang=js"
export * from "./risklabelTable.vue?vue&type=script&lang=js"

import "./risklabelTable.vue?vue&type=style&index=0&id=203e01cb&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@https+++registry.npmmirror.com+vue-loader+-+vue-loader-17.4.2.tgz_vue@3.2.13_webpack@5.95.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__